import { Box, Grid, Typography } from "@mui/material";
import { Bar, BarChart, CartesianGrid, Legend, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { LoadingButton } from "@mui/lab";
import { TIME_ITA } from "../../../../shared/constants/metric-chart-texts";
import { ProfitMetricDTO } from "../../../../entities/metrics/model/profit.model";
import { formatIntegerToCurrency } from "../../../../shared/lib/numbers";

interface Props {
  metrics: ProfitMetricDTO[];
  payedToTechniciansInfo: PayedToTechniciansInfo;
  billedInfo: BilledInfo;
  timeFrame: string;
  startDate: string;
  endDate: string;
}

interface PayedToTechniciansInfo {
  totalPayedToTechnicians: string;
  average: string;
}
interface BilledInfo {
  totalBilled: string;
  average: string;
  percentage: string;
  netProfit: string;
}

const NUOVAUTO_LOGO = require("../../../../assets/nuovauto.png");

export const ProfitBarchart = ({ metrics, payedToTechniciansInfo, billedInfo, timeFrame, startDate, endDate }: Props) => {
  const time = timeFrame.split("-")[1];
  const unit = timeFrame.split("-")[0];

  const chartRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => chartRef.current
  });

  useEffect(() => {
    console.log("mostrando metrics", metrics);
  }, [metrics]);

  return (
    <>
      <Grid container spacing={2} ref={chartRef} mt={5}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box component="img" src={NUOVAUTO_LOGO} ml={5} mb={2} sx={{ width: "320px" }} />
          <Box>
            <Typography variant="h4" ml={5}>
              Valor da perícia vs Custo de Técnicos
            </Typography>
          </Box>
        </Box>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <ResponsiveContainer width="100%" height={550}>
            <BarChart
              width={500}
              height={300}
              data={metrics}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar
                dataKey={(data) => +formatIntegerToCurrency(data.billed)}
                name="Valor/CHF"
                stackId="a"
                fill="#8884d8"
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />
              <Bar
                dataKey={(data) => +formatIntegerToCurrency(data.profit)}
                name="Lucro/CHF"
                stackId="a"
                fill="#8884d8"
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />
              <Bar
                dataKey={(data) => +formatIntegerToCurrency(data.payedToTechnicians)}
                name="Pago aos técnicos/CHF"
                fill="#82ca9d"
                activeBar={<Rectangle fill="gold" stroke="purple" />}
              />
            </BarChart>
          </ResponsiveContainer>
        </Grid>
        <Box ml={5} mt={5}>
          <Typography variant="body1">Total Faturado: {billedInfo.totalBilled}</Typography>
          <Typography variant="body1">Média faturada: {`${billedInfo.average}/${unit}`}</Typography>
        </Box>
        <Box ml={5} mt={5}>
          <Typography variant="body1">Total pago aos técnicos: {payedToTechniciansInfo.totalPayedToTechnicians}</Typography>
          <Typography variant="body1">Média paga aos técnicos: {`${payedToTechniciansInfo.average}/${unit}`}</Typography>
        </Box>
        <Box ml={5} mb={5} mt={5}>
          <Typography variant="body1">Lucro: {`${billedInfo.netProfit}`}</Typography>
          <Typography variant="body1">Margem de lucro: {`${billedInfo.percentage}`}</Typography>
        </Box>
        <Box ml={5} mb={5} mt={5}>
          <Typography variant="body1">
            {TIME_ITA}: {`${time} ${unit}`}
          </Typography>
        </Box>
      </Grid>
      <LoadingButton variant="outlined" onClick={handlePrint}>
        print
      </LoadingButton>
    </>
  );
};
